
import { Component, Prop, Vue } from "vue-property-decorator";
import vPreLoader from "@/components/vPreLoader.vue";
import { MlAllergenPrediction, MlAnalysisResponse } from "@/models/AllergenML/AllergenML";
import { NutrientSource } from "@/models/NutrientSource/NutrientSource";
import {
  beautifyAllergenId,
  formatAllergenName,
  getAllergenLabel,
  getCountryLabel,
  getFlaggedIngredientCount,
  isUkCerealsAllergen,
} from "@/components/allergens/allergenAnalysisResultsLogic";

@Component({
  components: {
    vPreLoader,
  },
})
export default class AllergenAnalysisResults extends Vue {
  @Prop({ default: false }) loading!: boolean;
  @Prop({ default: "" }) errorMessage!: string;
  @Prop({ default: null }) analysisResult!: MlAnalysisResponse | null;
  @Prop({ default: NutrientSource.US }) country!: NutrientSource;
  @Prop({ default: "Run the model to see detected allergens and substitute suggestions." }) emptyMessage!: string;
  @Prop({ default: true }) showSummary!: boolean;
  @Prop({ default: true }) showOverview!: boolean;

  get flaggedIngredientCount() {
    return getFlaggedIngredientCount(this.analysisResult);
  }

  get countryLabel() {
    return getCountryLabel(this.analysisResult, this.country);
  }

  beautifyId(value: string) {
    return beautifyAllergenId(value);
  }

  formatAllergenName(value: string) {
    return formatAllergenName(value);
  }

  allergenLabel(allergen: MlAllergenPrediction) {
    return getAllergenLabel(allergen, this.analysisResult, this.country);
  }

  isUkCerealsAllergen(allergenId: string, displayName: string) {
    return isUkCerealsAllergen(allergenId, displayName, this.analysisResult?.nutrientSource ?? this.country);
  }

}
